'use strict';

import Utility from "@/Common/Utility";

 
function ElementDragger() {
    this.ToMoveElement = null;
    this.SourceElement = null;
    this.AutoExpandSourceElement = false;
    this.HasBindWindowEvent = false;
    this.DragStartHandler = null;
    this.DraggingHandler = null;
    this.DropHandler = null;
    this.UseDefaultDrag = true;
    this.CanMoveX = true;
    this.CanMoveY = true;

    this.GetMinX = null;
    this.GetMaxX = null;

    this.GetMinY = null;
    this.GetMaxY = null;

    this.MinX = -10000;
    this.MaxX = 10000;

    this.MinY = -10000;
    this.MaxY = 10000;
}

ElementDragger.CurrentElementDragger = null;

ElementDragger.TriggerDragStart = false;

ElementDragger.OnDraggerMoveBarMouseMove = function (e) {

    if (ElementDragger.CurrentElementDragger != null) {
        ElementDragger.CurrentElementDragger.OnMoveBarMouseMove(e);
    }
}

ElementDragger.OnDraggerMoveBarMouseUp = function (e) {
    let lastElementDragger;

 
    if (ElementDragger.CurrentElementDragger != null) {
        lastElementDragger = ElementDragger.CurrentElementDragger;
        ElementDragger.CurrentElementDragger.OnMoveBarMouseUp(e);

        if (lastElementDragger.DropHandler != null) {
            lastElementDragger.DropHandler(e);
        }

        ElementDragger.LastDropTime = new Date();

        ElementDragger.TriggerDragStart = false;
    }

    if (this.DropHandler != null) {
        this.DropHandler(e);
    }

    Utility.SaveSession("Dragging", false);
}

ElementDragger.OnDraggerMoveBarBlur = function (e) {
    if (ElementDragger.CurrentElementDragger != null) {
        ElementDragger.CurrentElementDragger.OnMoveBarBlur(e);
    }

    Utility.SaveSession("Dragging", false);
}


ElementDragger.prototype.Attach = function (sourceElement, toMoveElement) {

    if (typeof (sourceElement) == "string") {
        this.SourceElement = document.getElementById(sourceElement);
    }
    else {
        this.SourceElement = sourceElement;
    }


    if (toMoveElement == null) {
        this.ToMoveElement = this.SourceElement;
    }
    else if (typeof (toMoveElement) == "string") {
        this.ToMoveElement = document.getElementById(toMoveElement);
    }
    else {
        this.ToMoveElement = toMoveElement;
    }
 
    this.SourceElement.addEventListener("mousedown", this.OnMoveBarMouseDown.bind(this));
}


ElementDragger.prototype.AttachAndDrag = function (sourceElement, toMoveElement, e) {

    Utility.SaveSession("Dragging", true);

    this.Attach(sourceElement, toMoveElement);
    this.OnMoveBarMouseDown(e);
}


ElementDragger.prototype.Detach = function () {

    if (this.SourceElement != null) {
        this.SourceElement.removeEventListener("mousedown", this.OnMoveBarMouseDown.bind(this));
    }

    this.DragStartHandler = null;
    this.DraggingHandler = null;
    this.DropHandler = null;
    this.SourceElement = null;
    this.ToMoveElement = null;

}

ElementDragger.prototype.GetMinX = function (e) {
}

ElementDragger.prototype.GetMax = function (e) {
}

ElementDragger.prototype.OnMoveBarMouseDown = function (e) {
    var offsetX, offsetY;

    ElementDragger.CurrentElementDragger = this;


    if (this.GetMinX != null) {
        this.MinX = this.GetMinX(e);
    }

    if (this.GetMaxX != null) {
        this.MaxX = this.GetMaxX(e);
    }

    //offsetX = this.SourceElement.offsetLeft - e.clientX;
    //offsetY = this.SourceElement.offsetTop - e.clientY;


    //alert(Utility.GetClientLeft(this.SourceElement) + "," + e.pageX);
    //offsetX = Utility.GetClientLeft(this.SourceElement) - e.pageX;
    //offsetY = Utility.GetClientTop(this.SourceElement) - e.pageY;

    offsetX = Utility.GetClientLeft(this.ToMoveElement) - e.pageX;
    offsetY = Utility.GetClientTop(this.ToMoveElement) - e.pageY;

    //console.log(offsetX + "," + offsetY);

    this.SourceElement.setAttribute("OffsetX", offsetX);
    this.SourceElement.setAttribute("OffsetY", offsetY);

    if (this.AutoExpandSourceElement) {
        this.SourceElement.style.height = (this.ToMoveElement.clientHeight - 10) + "px";
    }


    document.body.onselectstart = function () { return false };
}//end ElementDragger.prototype.OnMoveBarMouseDown = function (e) {


ElementDragger.prototype.OnMoveBarMouseMove = function (e) {
    var parentElement;
    var offsetX, offsetY;
    var targetX, targetY;
    var x, y;
     
    Utility.SaveSession("Dragging", true);
     
    offsetX = parseInt(ElementDragger.CurrentElementDragger.SourceElement.getAttribute("OffsetX"));
    offsetY = parseInt(ElementDragger.CurrentElementDragger.SourceElement.getAttribute("OffsetY"));

    //x = e.clientX + offsetX;
    //y = e.clientY + offsetY;
    x = e.pageX + offsetX;
    y = e.pageY + offsetY;

   
    parentElement = ElementDragger.CurrentElementDragger.ToMoveElement.parentElement;

    if (this.CanMoveX) {
        if (x < this.MinX) {
            if (this.UseDefaultDrag) {
                ElementDragger.CurrentElementDragger.ToMoveElement.style.left = this.MinX + "px";
            }
            targetX = this.MinX;
        }
        else if (this.MaxX < x) {
            if (this.UseDefaultDrag) {
                ElementDragger.CurrentElementDragger.ToMoveElement.style.left = this.MaxX + "px";
            }
            targetX = this.MaxX;
        }
        else {
            if (this.UseDefaultDrag) {
                ElementDragger.CurrentElementDragger.ToMoveElement.style.left = x + "px";
            }
            targetX = x;
        }
    }


    if (this.CanMoveY) {
        if (y < this.MinY) {
            if (this.UseDefaultDrag) {
                ElementDragger.CurrentElementDragger.ToMoveElement.style.top = this.MinY + "px";
            }
            targetY = this.MinY;
        }
        else if (this.MaxY < y) {
            if (this.UseDefaultDrag) {
                ElementDragger.CurrentElementDragger.ToMoveElement.style.top = this.MaxY + "px";
            }
            targetY = this.MaxY;
        }
        else {
            if (this.UseDefaultDrag) {
                ElementDragger.CurrentElementDragger.ToMoveElement.style.top = y + "px";
            }
            targetY = y;
        }
    }

    if (ElementDragger.TriggerDragStart == false) {
        if (this.DragStartHandler != null) {
   
            this.DragStartHandler(targetX, targetY, this.SourceElement, this);

            ElementDragger.TriggerDragStart = true;
        }
    }

    if (this.DraggingHandler != null) {
        this.DraggingHandler(targetX, targetY, this.SourceElement, this);
    }
}//end ElementDraggerControl.prototype.OnMoveBarMouseMove = function (e) {


ElementDragger.prototype.OnMoveBarMouseUp = function (e) {
    //ElementDragger.CurrentElementDragger.SourceElement.style.height = "40px";

    document.body.removeEventListener("mousemove", ElementDragger.CurrentElementDragger.OnMoveBarMouseMove);
    document.body.removeEventListener("mouseup", ElementDragger.CurrentElementDragger.OnMoveBarMouseUp)
    document.body.removeEventListener("blur", ElementDragger.CurrentElementDragger.OnMoveBarBlur);

    ElementDragger.CurrentElementDragger = null;
    ElementDragger.TriggerDragStart = false;

    document.body.onselectstart = null;
}


ElementDragger.prototype.OnMoveBarBlur = function (e) {


}


ElementDragger.prototype.GetClientLeft = function (element) {
    var clientTop = element.offsetLeft;


    while (element.tagName != "BODY") {
        if (element == null) {
            break;
        }
        element = element.offsetParent;
        if (element == null) {
            break;
        }
        clientTop += element.offsetLeft;
    };

    return clientTop;
}


ElementDragger.prototype.GetClientTop = function (element) {
    var clientTop = element.offsetTop;

    while (element.tagName != "BODY") {
        element = element.offsetParent;
        if (element == null) {
            break;
        }
        clientTop += element.offsetTop;
        if (element == null) {
            break;
        }

        if (element.style.position == "absolute") {
            break;
        }
    };

    return clientTop;
}


ElementDragger.prototype.InsideRect = function (point, rect) {
    let inside = false;

    if (
        (rect.left <= point.X && point.X <= rect.left + rect.width) &&
        (rect.top <= point.Y && point.Y <= rect.top + rect.height)
    ) {
        inside = true;
    }

    return inside;
}


if (!ElementDragger.HasBindWindowEvent) {
    setTimeout(
        function () {
             window.addEventListener("mousemove",
                ElementDragger.OnDraggerMoveBarMouseMove);

            window.addEventListener("mouseup",
                ElementDragger.OnDraggerMoveBarMouseUp);

            window.addEventListener("blur",
                ElementDragger.OnDraggerMoveBarBlur);
         },
        1000
    );

    ElementDragger.HasBindWindowEvent = true;
} 


export default ElementDragger;
